import React from 'react'
import DateWiseAttendance from './DateWiseAttendance'

const TodaysAttendance = () => {
  return (
    <DateWiseAttendance/>
  )
}

export default TodaysAttendance